import { AfterViewInit, ChangeDetectorRef, Component, OnInit, QueryList, ViewChildren } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ContentService } from "../../../services/content.service";
import { catchError, forkJoin, of } from "rxjs";
import { DonorJourneySection } from "../../../models/donor-journey-section.model";
import { JourneySectionComponent } from "../../../shared/journey-section/journey-section.component";
import { Contract } from "../../../models/contract.model";
import { AuthService } from "../../../services/auth.service";
import { NavigationService } from "../../../services/navigation.service";

@Component({
  selector: "app-provider-journey",
  templateUrl: "./provider-journey.component.html",
  styleUrl: "./provider-journey.component.scss",
})
export class ProviderJourneyComponent implements OnInit, AfterViewInit {
  userId: string | null = null;
  profileInfo: any;
  journeySections: DonorJourneySection[] = [];
  isLoading = true;
  currentUrl = "";
  contractStatus = "";
  contract: Contract | null = null;
  downloadingConsent = false;
  isComprehensiveQuestionnaireCompleted = false;
  private readonly comprehensiveQuestionnaireSectionId =
    "JS_28be6f2a-814f-47f6-9942-29a9d37565df";

  @ViewChildren(JourneySectionComponent) journeySectionsComponents!: QueryList<JourneySectionComponent>;
  expandedSectionId: string | null = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private contentService: ContentService,
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
    private navigationService: NavigationService
  ) {}

  ngOnInit(): void {
    this.userId = this.route.parent?.snapshot.paramMap.get("userId") || null;
    this.currentUrl = this.router.url;

    if (this.userId) {
      this.isLoading = true;
      // Get Donor Info for table
      forkJoin([
        this.contentService.getDonorAndRecipientProfileInfo(this.userId).pipe(
          catchError((error) => {
            console.error("Error fetching profile info:", error);
            return of(null); // Return null or empty object if the profile info fails
          })
        ),
        this.contentService
          .getAdminDonorJourneySectionsForUser(this.userId)
          .pipe(
            catchError((error) => {
              console.error("Error fetching journey sections:", error);
              return of([]); // Return empty array if the journey sections fail
            })
          ),
       
      ]).subscribe({
        next: ([profileInfo, journeySections]) => {
          // Handle the combined results
          this.profileInfo = profileInfo?.data; // Assign profile info to a variable
          this.journeySections = journeySections; // Assign journey sections to a variable
          const comprehensiveSection = journeySections.find(
            (section) => section.sectionId === this.comprehensiveQuestionnaireSectionId
          );
          this.isComprehensiveQuestionnaireCompleted =
            comprehensiveSection?.currentStatus === "Completed";
         
          this.isLoading = false; // Optional: Hide the loading indicator
        },
        error: (err) => {
          console.error("Error fetching data:", err);

          this.isLoading = false; // Optional: Hide the loading indicator even if there's an error
        },
      });
      // Get Donor Journey sections by user id
    } else {
      // TODO: Show an error message
    }
  }

  ngAfterViewInit(): void {
    this.journeySectionsComponents.changes.subscribe(() => {
      this.route.fragment.subscribe((sectionId) => {
        if (sectionId) {
          this.expandedSectionId = sectionId;
          this.cdr.detectChanges();
          this.scrollToSection(sectionId);
        }
      });
    });
  }

  scrollToSection(sectionId: string) {
    // Find the component instance matching the sectionId
    const targetSection = this.journeySectionsComponents.find((comp) => comp.section.sectionId === sectionId);

    if (targetSection) {
      // Scroll to the section
      setTimeout(() => {
        targetSection.elementRef.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // targetSection.isExpanded = true;
      }, 100); 

      // Expand the section
      // targetSection.isExpanded = true;
    } else {
      console.warn(`Section with ID ${sectionId} not found`);
    }
  }

  navigateToDashboard(): void {
    this.navigationService.navigateToDashboard();
  }
}
